import React from 'react'
import LeftmenuIn from '../Components/LeftmenuIn'
import DashnavIn from '../Components/DashnavIn'
import WorkshopsComp from './WorkshopsComp'

function Workshops() {
  return (
    <div className='mainContainer'>
        <LeftmenuIn/>
        <div className='theMainContainer'>
        <DashnavIn/>
        <WorkshopsComp/>
        
        </div>
    </div> 
  )
}

export default Workshops